export type Feature = {
  name: string;
  title: string;
  defaultEnabled?: boolean;
};

export const features: Feature[] = [
  {
    name: 'newRewardCalculator',
    title: 'New Reward Calculator',
    defaultEnabled: true,
  },
];

/**
 * Get the default feature flags based on the feature configuration.
 * Used to initialize features in localStorage when they haven't been set yet.
 */
export const getDefaultFeatureFlags = (): Record<string, boolean> => {
  return features.reduce(
    (acc, feature) => {
      if (feature.defaultEnabled !== undefined) {
        acc[feature.name] = feature.defaultEnabled;
      }
      return acc;
    },
    {} as Record<string, boolean>,
  );
};
